import ApiClient from './ApiClient';

class KanbanCardsAPI extends ApiClient {
  constructor() {
    super('kanban_cards', { accountScoped: true });
  }
}

export default new KanbanCardsAPI();
